export const QUANTITY_INPUT = {
  INTEGER: 'number',
  DECIMAL: 'decimal',
  DECIMAL_REVERSE: 'decimal_reverse',
}

export const DEFAULT_MOVEMENT_FIELD_CONFIG = {
  pu: { decimals: 2, freeDecimal: false },
  quantidade: { decimals: 0, inputType: QUANTITY_INPUT.INTEGER },
}

const MOVEMENT_FIELD_CONFIG_BY_TYPE = {
  personalizado: {
    pu: { decimals: 8, freeDecimal: true },
    quantidade: { decimals: 8, inputType: QUANTITY_INPUT.DECIMAL },
  },
  'personalizado offshore': {
    pu: { decimals: 8, freeDecimal: true },
    quantidade: { decimals: 8, inputType: QUANTITY_INPUT.DECIMAL },
  },
  offshore: {
    quantidade: { decimals: 15, inputType: QUANTITY_INPUT.DECIMAL_REVERSE },
  },
  'fundos offshore': {
    quantidade: { decimals: 15, inputType: QUANTITY_INPUT.DECIMAL_REVERSE },
  },
  criptoativos: {
    quantidade: { decimals: 15, inputType: QUANTITY_INPUT.DECIMAL_REVERSE },
  },
  bonds: {
    quantidade: { decimals: 15, inputType: QUANTITY_INPUT.DECIMAL_REVERSE },
  },
  'fundos de investimentos': {
    pu: { decimals: 8 },
    quantidade: { decimals: 8, inputType: QUANTITY_INPUT.DECIMAL },
  },
  'fundos de previdência': {
    pu: { decimals: 8 },
    quantidade: { decimals: 8, inputType: QUANTITY_INPUT.DECIMAL },
  },
  fundos: {
    pu: { decimals: 8 },
    quantidade: { decimals: 8, inputType: QUANTITY_INPUT.DECIMAL },
  },
  fundo: {
    pu: { decimals: 8 },
    quantidade: { decimals: 8, inputType: QUANTITY_INPUT.DECIMAL },
  },
  'fundos de investimento': {
    pu: { decimals: 8 },
    quantidade: { decimals: 8, inputType: QUANTITY_INPUT.DECIMAL },
  },
  'fundo de investimento': {
    pu: { decimals: 8 },
    quantidade: { decimals: 8, inputType: QUANTITY_INPUT.DECIMAL },
  },
  'renda fixa': {
    pu: { decimals: 8 },
    quantidade: { decimals: 2, inputType: QUANTITY_INPUT.DECIMAL },
  },
  'tesouro direto': {
    pu: { decimals: 8 },
    quantidade: { decimals: 2, inputType: QUANTITY_INPUT.DECIMAL },
  },
}

export const getMovementFieldConfig = ({ tipo, Tipo } = {}) => {
  const override =
    MOVEMENT_FIELD_CONFIG_BY_TYPE[(tipo || Tipo || '').toLowerCase()] || {}
  return {
    pu: { ...DEFAULT_MOVEMENT_FIELD_CONFIG.pu, ...override.pu },
    quantidade: {
      ...DEFAULT_MOVEMENT_FIELD_CONFIG.quantidade,
      ...override.quantidade,
    },
  }
}
